import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 船員役割マスター
const enterpriseCrewRoleRepository = AiseaApiFactory.get("enterpriseCrewRole");

/**
 * 船員役割マスターサービス
 */
const EnterpriseCrewRoleService = (() => {
  let _enterpriseCrewRoles = null;

  const fetch = async () => {
    const res = await enterpriseCrewRoleRepository.search();
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseCrewRoles = res.data;
    return _enterpriseCrewRoles;
  };

  const clear = () => {
    _enterpriseCrewRoles = null;
  };

  const findById = id => {
    if (!_enterpriseCrewRoles) {
      return null;
    }

    return _enterpriseCrewRoles.roles.find(role => role.id === id) || null;
  };

  return {
    fetch,
    clear,
    findById,
  };
})();

export default EnterpriseCrewRoleService;
